import { render } from "./ErpCustomerRelationList.vue?vue&type=template&id=3b0eeb0c&scoped=true"
import script from "./ErpCustomerRelationList.vue?vue&type=script&lang=js"
export * from "./ErpCustomerRelationList.vue?vue&type=script&lang=js"

import "./ErpCustomerRelationList.vue?vue&type=style&index=0&id=3b0eeb0c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0eeb0c"],['__file',"src/views/h5/ai/erpCustomerRelation/ErpCustomerRelationList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b0eeb0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b0eeb0c', __exports__)) {
    api.reload('3b0eeb0c', __exports__)
  }
  
  module.hot.accept("./ErpCustomerRelationList.vue?vue&type=template&id=3b0eeb0c&scoped=true", () => {
    api.rerender('3b0eeb0c', render)
  })

}


export default __exports__